<ng-template let-editableProcess="editableProcess" let-isOnTop="isOnTop" #buttonbar>
	<stages-buttons-bottom [isOnTop]="isOnTop" [removeTopPadding]="true">
		<stages-button
			[buttonType]="'button'"
			[buttonCSS]="'button sm cancel'"
			[title]="'cancel'"
			(clicked)="cancel()"
		></stages-button>
		<stages-button
			[buttonType]="'submit'"
			[buttonCSS]="'button sm save'"
			[title]="'save'"
			[disabled]="isSaveInProgress"
			[showLoadingSpin]="isSaveInProgress"
			(clicked)="save(editableProcess)"
		>
		</stages-button>
	</stages-buttons-bottom>
</ng-template>

<ng-container *ngIf="workspaceView$ | async as workspaceView">
	<ng-container *ngIf="data$ | async as data">
		<article class="edit-element" *ngIf="editableProcess$ | async as editableProcess">
			<stages-page-header [headline]="headline" [backButtonWithRouterLink]="backButton"></stages-page-header>
			<article class="card">
				<ng-container
					*ngTemplateOutlet="buttonbar; context: { editableProcess: editableProcess, isOnTop: true }"
				></ng-container>
				<form class="form" [formGroup]="formGroup" #formElement>
					<div class="input-container">
						<label class="input-label" for="edt1" translate="process.element.edit.description"></label>
						<stages-description-editor
							[editorId]="'processDescriptionEditor'"
							[modifiable]="true"
							[unsafe]="false"
							[description]="editableProcess.process.displayDescription"
							[processTypeIdent]="data.view.processView.processType"
							[pluginRegistry]="pluginRegistry"
							[beanType]="data.view.processView.type.ident"
							[beanId]="data.view.processView.id"
							[beanIdentity]="data.view.processView.identity"
							[workspaceId]="workspaceView.currentWorkspace.id"
							[pv]="workspaceView.currentWorkspace.viewedProcess!.versionIdentifier"
						>
						</stages-description-editor>
						<div class="info"></div>
					</div>

					<stages-attribute-edit
						[attributeTypes]="editableProcess.attributeTypes"
						[attributes]="editableProcess.process.attributes"
						[form]="formGroup"
						[richtextInputContext]="getContext(data, workspaceView)"
					>
					</stages-attribute-edit>

					<div class="info"></div>
					<ng-container
						*ngTemplateOutlet="buttonbar; context: { editableProcess: editableProcess, isOnTop: false }"
					></ng-container>
				</form>
			</article>
		</article>
	</ng-container>
</ng-container>
